(function () {
	/* 30AGear 2026-10-23: initialise each ticker track exactly once.
	   sections/ticker.liquid includes this file, so a page with two ticker
	   sections ran it twice, and each run built a Swiper for EVERY ticker: two
	   instances on one track. The pause control stops el.swiper (the second)
	   while the first kept scrolling. The guard is per track rather than
	   "load once", so the theme editor's re-render of one section still
	   initialises that section's new track.
	   `[data-ticker-id]` skips Shopify's <section class="ticker"> wrapper,
	   which carries the same class (schema "class": "ticker") and used to get
	   a no-op Swiper on `.ticker-js-undefined`.
	   prefers-reduced-motion: autoplay starts disabled; the pause control's
	   Play button can still start it (assets/a11y-carousel.js). */
	const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
	const tickSlider = () => {
		$(".ticker[data-ticker-id]").each(function () {
			const $this = $(this);
			const id = $this.attr("id");
			const tickerId = $this.data("ticker-id");
			const track = document.querySelector(`#${id} .ticker-js-${tickerId}`);
			if (!track || track.dataset.tickerInit) return;
			track.dataset.tickerInit = "true";
			const tickerSpeed = $this.data("ticker-speed") * 1000;
			new Swiper(track, {
				slidesPerView: "auto",
				speed: tickerSpeed,
				initialSlide: 0,
				loop: true,
				allowTouchMove: false,
				waitForTransition: false,
				watchSlidesProgress: false,
				autoplay: {
					enabled: !reduceMotion,
					delay: 0,
					disableOnInteraction: false,
				},
			});
		});
	};
	document.addEventListener("shopify:section:load", function () {
		setTimeout(() => {
			tickSlider();
		}, 100);
	});
	setTimeout(() => {
		tickSlider();
	}, 100);
})();
